import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  _id: null,
}

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    updateAgentSlice: (state, action) => {
      // console.log(state)
      // console.log(action)
      console.log(action.payload)
      return {
        ...action.payload,
      }
    },
    //to add logout reducer here
  },
})

// console.log(agentSlice)

export const {updateAgentSlice} = agentSlice.actions

export default agentSlice.reducer
